import ButtonIcon from "#common/buttons/ButtonIcon"
import PERMISOS from "#constants/perfiles"
import ChipStatus from "#core/components/ChipStatus"
import { UseHasPermission } from "#hooks/useHasPermission"
import { UseJobProfileDetailsContexts } from "#job-profile/contexts/JobProfileDetailsContexts"
import { Edit } from "@mui/icons-material"
import CancelIcon from "@mui/icons-material/Cancel"
import CheckIcon from "@mui/icons-material/Check"
import Groups2Icon from "@mui/icons-material/Groups2"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { Badge, Box, Chip, Paper, Typography } from "@mui/material"
import { useState } from "react"
import { JobProfileFormDialog } from "../job-profile/JobProfileForm"
import ApproveDialog from "./dialog/ApproveDialog"
import ColaboradoresDialog from "./dialog/ColaboradoresDialog"
import DeactivatedDialog from "./dialog/DeactivatedDialog"
import HistoryDialog from "./dialog/HistoryDialog"

export default function JobProfileDetailsHeader() {
	const { jobProfile, refresh } = UseJobProfileDetailsContexts()
	const [open, setOpen] = useState(false)
	const isRh = UseHasPermission(PERMISOS.RH)
	if (!jobProfile) return null

	const items = [
		{
			title: "Colaboradores con perfil",
			icon: () => (
				<Badge
					badgeContent={jobProfile.assignees_count}
					color="error"
					variant={"standard"}
					overlap="rectangular"
				>
					<Groups2Icon color={"primary"} />
				</Badge>
			),
			component: ColaboradoresDialog,
		},
		{ title: "Historial", icon: ScheduleIcon, component: HistoryDialog },
		{
			title: "Editar Perfil Puesto",
			icon: Edit,
			hidden: isRh ? false : !jobProfile.habilitado === true,
			component: JobProfileFormDialog,
		},
		{
			title: "Desactivar Perfil Puesto",
			icon: CancelIcon,
			hidden: jobProfile.habilitado === false,
			color: "error",
			component: DeactivatedDialog,
		},
		{
			title: "Habilitar Perfil Puesto",
			icon: CheckIcon,
			hidden: jobProfile.habilitado,
			component: ApproveDialog,
			color: "success",
		},
	]
	const itemsDialog = []
	const itemsButton = items.map((item) => {
		const Dialog = item.component
		itemsDialog.push(
			<Dialog
				{...{
					open: open === item.title,
					setOpen,
					profileData: jobProfile,
					refresh,
				}}
			/>
		)
		return (
			<ButtonIcon
				{...item}
				icon={<item.icon color={item?.color || "primary"} />}
				onClick={() => setOpen(item.title)}
			/>
		)
	})

	return (
		<Paper elevation={1} sx={{ p: 3, mb: 3 }}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "flex-start",
				}}
			>
				<Box>
					<Typography variant="h4" component="h1" gutterBottom>
						{jobProfile.nombre}
					</Typography>
					<Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
						{jobProfile.habilitado === null ? (
							<Chip label={"Pendiente De Revisión"} color={"success"} size={"medium"} />
						) : (
							<ChipStatus
								status={jobProfile.habilitado}
								activo="Habilitado"
								desactivado="Deshabilitado"
								size="medium"
							/>
						)}
					</Box>
				</Box>
				<Box sx={{ display: "flex", gap: 1 }}>
					{itemsButton}
					{itemsDialog}
				</Box>
			</Box>
		</Paper>
	)
}
